import { Component, Input } from '@angular/core';

@Component({
	selector: 'lib-new-campaign-summary',
	templateUrl: './summary.component.html',
	styleUrls: ['./summary.component.scss'],
})
export class SummaryComponent {
	@Input() public isShowLabel: boolean;
}
